import { useTranslation } from 'react-i18next';
import { Calendar } from 'components/Calendar/Calendar';
import { CalendarBadge } from 'components/Calendar/CalendarBadge';
import { Legend } from 'components/Charts/Legend';
import { defaultMeasurementIndicators, getHeartRhythmIndicatorColor } from 'utils/measurement';
import { PaperWithBorder } from 'components/PaperWithBorder';
import { useHeartRhythmOverview } from 'hooks/api/useHeartRhythmData';
import { usePatientDetailContext } from 'context/hooks';

export const HeartRateCalendar = () => {
  const { t } = useTranslation();
  const { data: measurements, isLoading, getItemById, handleSelected } = useHeartRhythmOverview();
  const { startDate, endDate } = usePatientDetailContext();

  const rhythmLegendItems = [
    ...Object.values(defaultMeasurementIndicators).map((indicator) => ({
      color: getHeartRhythmIndicatorColor(indicator),
      title: t(`indicator_label_${indicator}`),
    })),
    {
      color: 'var(--mantine-color-black)',
      title: t('severity_symptoms_present'),
      innerColor: 'var(--mantine-color-gray-3)',
    },
  ];

  return (
    <PaperWithBorder title={t('patients_calendar_title')} isLoading={isLoading} testId={'heart-rate-calendar'}>
      <Legend items={rhythmLegendItems} />
      <Calendar
        range={{
          startDate,
          endDate,
        }}
        events={
          measurements
            ? measurements?.map((item, index) => ({
                id: item.id || `patientMeasurements-${index}`,
                date: item.data?.measurement_timestamp || 0,
              }))
            : []
        }
        renderItem={(calendarItem) => (
          <CalendarBadge
            key={calendarItem.id}
            item={getItemById(calendarItem.id)}
            onClick={(item) => handleSelected(item)}
          />
        )}
      />
    </PaperWithBorder>
  );
};
